import { useQuery } from '@apollo/client';
import { useAuth } from '@app/_context/authContext';
import { getAnonymousWishlistItemQuery } from '@server/queries/anonymousWishlist';
import { getWishlistItemQuery } from '@server/queries/wishlist';

export default function usePDPWishlist({
    productId,
    wishlistCookies,
}: {
    productId: string;
    wishlistCookies?: { id?: number; token?: string };
}) {
    const { auth } = useAuth();

    const { data: wishlistItemData } = useQuery(getWishlistItemQuery, {
        variables: {
            productId,
            token: auth?.token || '',
        },
        skip: !auth?.token,
        fetchPolicy: 'network-only',
    });
    const { data: anonymousWishlistItemData } = useQuery(
        getAnonymousWishlistItemQuery,
        {
            variables: {
                productId,
                wishlistId: wishlistCookies?.id as number,
                wishlistToken: wishlistCookies?.token as string,
            },
            skip:
                !!auth?.token ||
                (!wishlistCookies?.id && !wishlistCookies?.token),
            fetchPolicy: 'network-only',
        },
    );

    const { data, error, isError } =
        (auth?.token
            ? wishlistItemData?.getWishlistItem
            : anonymousWishlistItemData?.getAnonymousWishlistItem) || {};

    return {
        data,
        error,
        isError,
    };
}
